import iconExternal from '@/icons/external.svg?raw'

import { GlobalState } from '@/scripts/config/globalState'
import Analytics, { ACTION_LINK_CLICK } from '@/scripts/analytics'
import type { Page } from '@/scripts/data/types'
import { isArchive } from '@/scripts/config/settings'

function renderDesktopLinks() {
  renderLinkList('.icon-links', true)
  renderLinkList('.text-links', false)
}

function renderMobileLinks() {
  // In archive mode, don't render mobile links
  if (isArchive) {
    return
  }

  const container = document.querySelector('.mobile-links')
  if (!container) return

  GlobalState.pages.forEach((page) => {
    const li = document.createElement('li')
    li.className = 'menu__list-item'

    const img = document.createElement('img')
    img.className = 'menu__item-image'
    img.src = `${import.meta.env.BASE_URL}images/page/menu-icons/${page.id}.png`
    img.alt = ''

    const content = document.createElement('div')
    content.className = 'menu__item-content'

    const h2 = document.createElement('h2')
    h2.className = 'menu__item-title'

    const a = document.createElement('a')
    a.className = 'menu__item-link'
    a.href = page.linkHash ? `#${page.linkHash}` : (page.url ?? '')

    if (page.url && !page.linkHash) {
      a.target = '_blank'

      const external = document.createElement('div')
      external.className = 'menu__item-icon-external'
      external.innerHTML = iconExternal
      a.appendChild(document.createTextNode(page.title))
      a.appendChild(external)
    } else {
      a.textContent = page.title
    }

    a.addEventListener('click', () => {
      Analytics.sendCustomEvent(ACTION_LINK_CLICK, page.id)
    })

    const description = document.createElement('p')
    description.className = 'menu__item-description'
    description.textContent = page.description ?? ''

    h2.appendChild(a)
    content.appendChild(h2)
    content.appendChild(description)

    li.appendChild(img)
    li.appendChild(content)

    container.appendChild(li)
  })
}

function renderLinkList(selector: string, isIconList: boolean) {
  const container = document.querySelector(selector)
  if (!container) return

  const pages = GlobalState.pages.filter((p) => (isIconList ? !!p.icon : !p.icon))

  pages.forEach((page) => {
    const li = document.createElement('li')
    const a = createLinkElement(page, isIconList)

    li.appendChild(a)
    container.appendChild(li)
  })
}

function createLinkElement(page: Page, isIcon: boolean): HTMLAnchorElement {
  const a = document.createElement('a')

  a.className = isIcon ? 'button icon-button' : 'button'
  a.href = page.linkHash ? `#${page.linkHash}` : (page.url ?? '')
  a.innerHTML = isIcon ? (page.icon ?? '') : page.title

  if (page.url && !page.linkHash) {
    a.target = '_blank'
  }

  if (isIcon) {
    a.ariaLabel = page.title
    a.dataset.balloonPos = 'up-left'
  }

  a.addEventListener('click', () => {
    Analytics.sendCustomEvent(ACTION_LINK_CLICK, page.id)
  })

  return a
}

export default { renderMobileLinks, renderDesktopLinks }
